import { ActionPattern, take } from "redux-saga/effects";

export function* waitAction(action: ActionPattern) {
  while (true) {
    const actionResult = yield take(action);

    if (actionResult !== undefined) {
      break;
    }
  }
}
